import { Card, Col, Progress, Space } from "antd";

interface ICircleProgress {
    title: string;
    subtitle: string;
    percent: number;
    mdSize: number;
    currentUsage?: number;
    limit?: number;
}

const CircleProgress = ({
    title,
    subtitle,
    percent,
    mdSize,
    currentUsage,
    limit
}: ICircleProgress) => {
    return (
        <Col xs={24} md={mdSize}>
            <Card>
                <Space direction="vertical" align="center" className="flex-align-center">
                    <div style={{ textAlign: "center" }}>
                        <div style={{ fontWeight: 500, fontSize: 16 }}>
                            {title}
                        </div>
                        <small>{subtitle}</small>
                    </div>
                    <Progress
                        type="circle"
                        strokeColor={{
                            '0%': '#108ee9',
                            '100%': '#87d068',
                        }}
                        format={() => {
                            return currentUsage !== undefined && limit !== undefined ?
                                <div style={{ fontSize: 18, color: "#112d3d", fontWeight: 500 }}>
                                    {currentUsage} / {limit}
                                </div> :
                                <div style={{ fontSize: 12 }}>
                                    No information available
                                </div>
                        }}
                        percent={percent}
                        width={100}
                    />
                </Space>
            </Card>
        </Col>
    )
}

export default CircleProgress;